// Jump and Move of 50+ shown as ∞. notables.json gives Teleport and Ignore Height +50 Jump, and Teleport 2 +50 Move
// and Jump: an old stopgap the math is happy with (50 clears any map's height, and the sim gives fliers 99 anyway), but
// the cards read "Jump 54". Display only: every check, the sim and the grades keep the raw number.
export const UNLIMITED = 50;
const ENDLESS = new Set(['move', 'jump']);

export const isEndless = (k, v) => ENDLESS.has(k) && Number(v) >= UNLIMITED;

// The value to show: ∞ for an unlimited Jump or Move, else the value unchanged.
export const fmtStat = (k, v) => (isEndless(k, v) ? '∞' : v);

// The hover for an ∞: what makes it unlimited ("Teleport: ignores height"). Null for an ordinary value.
export function endlessTip(k, v, unit) {
  if (!isEndless(k, v)) return null;
  const why = k === 'jump' ? 'ignores height' : 'can move anywhere on the map';
  return ((unit && unit.MoveSkill) || 'Its move skill') + ': ' + why;
}

// A stat averaged across units with the unlimited ones counted apart, so one Teleporter doesn't turn a team's
// Jump 4.0 into 16.3: "4.0", "4.0 · 1 ∞", or "∞" when every unit is unlimited.
export function avgStat(k, values) {
  const fin = values.filter((v) => !isEndless(k, v)).map((v) => Number(v) || 0);
  const inf = values.length - fin.length;
  const avg = fin.length ? (fin.reduce((a, b) => a + b, 0) / fin.length).toFixed(1) : null;
  if (!inf) return avg == null ? '–' : avg;
  return avg == null ? '∞' : avg + ' · ' + inf + ' ∞';
}
